import React, { useState } from 'react'
import clsx from 'clsx'

export interface SidePanelImageIconProps {
  src: string
  alt?: string
  width: number
  height: number
  hasBackgroundColor?: boolean
}

export const SidePanelImageIcon = ({
  src,
  alt,
  width,
  height,
  hasBackgroundColor = true,
}: SidePanelImageIconProps) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div
      style={{ width: `${width}px`, height: `${height}px` }}
      className={clsx(
        'rounded-full',
        hasBackgroundColor && 'bg-gray-04',
        isLoading && 'animate-pulse'
      )}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ width: `${width}px`, height: `${height}px` }}
        className="bg-transparent"
        onLoad={() => setIsLoading(false)}
        onError={event => {
          const el = event.target as HTMLImageElement
          el.onerror = null
          el.src = `${src}fallback.svg`
        }}
      />
    </div>
  )
}
